{
  "page_count": "of {n, plural, one{# page} other{# pages}}"
}
